import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/main'
import Main1 from '@/pages/main1'
import Main2 from '@/pages/main2'
import Main3 from '@/pages/main3'
import MainClass from '@/pages/mainclass'
import MainClass1 from '@/pages/mainclass1'
import MainClass2 from '@/pages/mainclass2'
import MainClass3 from '@/pages/mainclass3'
import Block1 from '@/pages/Block1'
import Block3 from '@/pages/Block3'
import Block4 from '@/pages/Block4'
import XS from '@/pages/xs'
import BT from '@/pages/bt'
import Setting from '@/pages/setting'
import Yingyun from '@/pages/yingyun'
import Jiaoban from '@/pages/jiaoban'
import Yichang from '@/pages/yichang'
import Hjyingyun from '@/pages/hjyingyun'
import Hjjiaoban from '@/pages/hjjiaoban'
import Hjyichang from '@/pages/hjyichang'
import Hjyichangcard from '@/pages/hjyichangcard'
import Hjyichangzhuan from '@/pages/hjyichangzhuan'
import Hjchange from '@/pages/hjchange'
import Hjtiaozheng from '@/pages/hjtiaozheng'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main
    },
      {
          path: '/mainclass',
          name: 'mainclass',
          component: MainClass
      },
      {
          path: '/xs',
          name: 'xs',
          component: XS
      },
      {
          path: '/bt',
          name: 'bt',
          component: BT
      },
      {
          path: '/mainclass1',
          name: 'mainclass1',
          component: MainClass1
      }
      ,
      {
          path: '/mainclass2',
          name: 'mainclass2',
          component: MainClass2
      }
      ,
      {
          path: '/mainclass3',
          name: 'mainclass3',
          component: MainClass3
      },
      {
          path: '/block1',
          name: 'block1',
          component: Block1
      },
      {
          path: '/block3',
          name: 'block3',
          component: Block3
      },
      {
        path: '/block4',
        name: 'block4',
        component: Block4
    },
      {
          path: '/main1',
          name: 'main1',
          component: Main1
      },
      {
          path: '/main2',
          name: 'main2',
          component: Main2
      },
      {
          path: '/main3',
          name: 'main3',
          component: Main3
      },
    {
      path: '/setting',
      name: 'setting',
      component: Setting
    },
    {
      path: '/yingyun',
      name: 'yingyun',
      component: Yingyun
    },
    {
      path: '/jiaoban',
      name: 'jiaoban',
      component: Jiaoban
    },
    {
      path: '/yichang',
      name: 'yichang',
      component: Yichang
    },
    {
      path: '/hjyingyun',
      name: 'hjyingyun',
      component: Hjyingyun
    },
    {
      path: '/hjjiaoban',
      name: 'hjjiaoban',
      component: Hjjiaoban
    },
    {
      path: '/hjyichang',
      name: 'hjyichang',
      component: Hjyichang
    },
    {
      path: '/hjyichangcard',
      name: 'hjyichangcard',
      component: Hjyichangcard
    },
    {
      path: '/hjyichangzhuan',
      name: 'hjyichangzhuan',
      component: Hjyichangzhuan
    },
    {
      path: '/hjchange',
      name: 'hjchange',
      component: Hjchange
    },
    {
      path: '/hjtiaozheng',
      name: 'hjtiaozheng',
      component: Hjtiaozheng
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js